export default "__VITE_ASSET__gaTQ8ho7__"